var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 3.59846C2.48367 3.59846 3.20002 2.88211 3.20002 1.99845C3.20002 1.11479 2.48367 0.398438 1.60001 0.398438C0.716349 0.398438 0 1.11479 0 1.99845C0 2.88211 0.716349 3.59846 1.60001 3.59846Z",
    fill: "#E8ECF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99845 3.59846C8.88211 3.59846 9.59846 2.88211 9.59846 1.99845C9.59846 1.11479 8.88211 0.398438 7.99845 0.398438C7.11479 0.398438 6.39844 1.11479 6.39844 1.99845C6.39844 2.88211 7.11479 3.59846 7.99845 3.59846Z",
    fill: "#E8ECF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3969 3.59846C15.2805 3.59846 15.9969 2.88211 15.9969 1.99845C15.9969 1.11479 15.2805 0.398438 14.3969 0.398438C13.5132 0.398438 12.7969 1.11479 12.7969 1.99845C12.7969 2.88211 13.5132 3.59846 14.3969 3.59846Z",
    fill: "#E8ECF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotImg);
export default __webpack_public_path__ + "static/media/three_dot_img.ed75404b0be762a10412fe885afe9f27.svg";
export { ForwardRef as ReactComponent };